import { Injectable } from '@angular/core';

@Injectable()
export class BannerSliderService {

    test() {
        console.log('Test method');
    }

}
